export default {
  list: '/v3/recruit/online/auth/list'
}
